import styled from "styled-components";
import { Modal } from "components/Modal";

export const UpdateBankAccountConfirmationModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 480px;

    .modal-content {
      padding: 0;
      border-radius: 16px;

      .modal-body {
        padding: 0;
        margin-top: 0;

        .modal-header {
          padding: 20px 24px;
          border-bottom: 1px solid ${({ theme }) => theme.input.border.color};

          .modal-title {
            margin: 0;
            font-size: 18px;
            font-weight: 500;
            color: ${({ theme }) => theme.card.font.tertiary};
            font-family: "Geist", sans-serif;
          }
        }

        .modal-body-content {
          padding: 24px;

          .info-banner {
            display: flex;
            gap: 12px;
            padding: 12px 16px;
            background: #eff6ff;
            border: 1px solid #bfdbfe;
            border-radius: 8px;
            margin-bottom: 24px;

            .info-icon {
              flex-shrink: 0;
              width: 20px;
              height: 20px;
              color: #3b82f6;
              display: flex;
              align-items: center;
              justify-content: center;

              svg {
                width: 20px;
                height: 20px;
              }
            }

            .info-text {
              font-size: 14px;
              font-weight: 400;
              color: #1e40af;
              line-height: 1.5;
              margin: 0;
              font-family: "Geist", sans-serif;
            }
          }

          .action-buttons {
            display: flex;
            gap: 12px;

            .cancel-button,
            .confirm-button {
              flex: 1;
              padding: 12px;
              border-radius: 8px;
              font-size: 16px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.2s ease;
              font-family: "Geist", sans-serif;
              border: none;
            }

            .cancel-button {
              background: #ffffff;
              border: 1px solid #d5d7da;
              color: #374151;

              &:hover {
                background: #f9fafb;
              }
            }

            .confirm-button {
              background: #2563eb;
              color: #ffffff;

              &:hover {
                background: #1d4ed8;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .modal-dialog {
      max-width: 100%;
      margin: 0 16px;

      .modal-content {
        .modal-body {
          .modal-header {
            padding: 16px 20px;

            .modal-title {
              font-size: 16px;
            }
          }

          .modal-body-content {
            padding: 20px;

            .action-buttons {
              flex-direction: column-reverse;

              .cancel-button,
              .confirm-button {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
`;
